import { css } from 'lit';
import componentStyles from '../styles/component.styles';
export default css `
${componentStyles}
/**
--------------------------------------------------
* General
--------------------------------------------------
*/
:host {
  display: block;
}

.inline-list {
  display: flex;
  flex-wrap: wrap;
  gap: .5rem;
  list-style: none;
  padding: 0;
  margin: 0;
}

hr {
	border: 0;
  color: inherit;
  height: 1px;
  background: var(--p-border);
  margin: 1em 0;
}

.label {
  display: block;
  word-break: break-word;
  font-size: var(--p-label-font-size, .9rem);
  line-height: var(--p-label-line-height, 1.3);
  font-weight: var(--p-label-font-weight, bold);
  margin-bottom: var(--p-label-margin-bottom, .5em);
  color: var(--p-text-color);
}

.copy-wrap {
  display: flex;
  gap:10px;
  align-items: flex-end;
  margin-bottom: var(--p-input-margin-bottom);
}

.copy-wrap p-input, .copy-wrap p-textarea{
  width: 100%;
  --p-input-margin-bottom: 0;
}

`;
